//get status.
export function getQuestionsStatus(questions) {
    let status = {
        answered: 0,
        marked: 0,
        notAnswered: 0,
        notVisited: 0,
        totalQuestions: 0
    };
    if (questions && questions.length > 0) {
        status = questions.reduce((total, item) => {
            if (item.answered) {
                total.answered++;
            }
            if (item.marked) {
                total.marked++;
            }
            if (!item.visited) {
                total.notVisited++;
            }
            if (!item.answered && item.visited) {
                total.notAnswered++;
            }
            return total;
        }, status);
        status.totalQuestions = questions.length;
    }
    return status;
}